<template>
  <div>
    <div class="bg-card bg-white border-card-border md:px-6">
      <div class="w-full pt-3">
        <h1 class="text-center text-xl font-semibold text-default pb-4">
          Congratulations! You have been approved for a VIVA Finance Loan!
        </h1>
        <h2 class="text-center text-gray-600 pb-2">
          VIVA's loans are automatically repaid through payroll, so you can set it and forget it.
          <b>Click the button below to accept your offer and set up your automatic repayment.</b>
        </h2>
        <h2 class="text-center text-gray-600">
          If you have any questions regarding your offer or our loans, please check out our
          <a href="/faq" class="nav-link hover viva-green-text"
            ><b>Frequently Asked Questions</b></a
          >
          or call our Customer Success Team at (678) 685-8834.
        </h2>
        <div class="flex justify-center">
          <div class="flex justify-center w-800">
            <div class="grid grid-col-1 items-center border border-black m-3 p-3 gap-2 w-400">
              <span class="viva-green-text text-lg text-center"><b>Offer Details</b></span>
              <div class="text-center">
                <p>
                  <b>{{ offerAmountFinanced }}</b>
                </p>
                <p>Loan Amount</p>
              </div>
              <div class="text-center">
                <p>
                  <b>{{ offerOriginalAPR }}%</b>
                </p>
                <p>Effective APR</p>
              </div>
              <div class="text-center">
                <p>
                  <b>{{ offerTotalCost }}</b>
                </p>
                <p>Total Cost</p>
              </div>
              <div class="text-center">
                <p>
                  <b>{{ offerTerm }}</b>
                </p>
                <p>Term</p>
              </div>
              <div class="text-center">
                <p>
                  <b>{{ offerPaymentAmount }}</b>
                </p>
                <p>Monthly Amount Due</p>
              </div>
              <div class="text-center">
                <p>
                  <b>{{ offerDeductionAmount }}</b>
                </p>
                <p>Payments Per Pay Period</p>
              </div>
              <div class="text-center">
                <p>
                  <b>{{ expectedPayments }}</b>
                </p>
                <p>Expected Payments</p>
              </div>
            </div>
            <div class="hidden md:flex items-center m-3">
              <img
                class=""
                alt="celebrate!"
                :src="require('@/assets/img/sketches/celebration.svg')"
              />
            </div>
          </div>
        </div>
        <div class="grid justify-items-center m-3">
          <base-button
            type="primary"
            aria-label="Set up direct deposit and accept offer"
            @click="acceptOffer"
          >
            Accept Offer
          </base-button>
        </div>
        <p class="text-center text-xs text-gray-600 m-3 mt-6">
          In the event that a payment is not made through your standard payroll direct deposit or
          payment is less than the standard amount, VIVA will automatically debit your linked Bank
          Account so you can stay on track with your payments. Please send an email to
          <a href="mailto: info@viva-finance.com" class="text-blue-500 no-underline hover-underline"
            >info@viva-finance.com</a
          >
          to opt-out of Auto ACH payments at least 3 business days before your pay date.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import Swal from 'sweetalert2'

export default {
  data() {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    })
    return {
      offerAmountFinanced: formatter.format(this.$store.getters.offerAmountFinanced),
      offerOriginalAPR: this.$store.getters.offerOriginalAPR,
      offerTotalCost: formatter.format(this.$store.getters.offerTotalCost),
      offerTerm: this.$store.getters.offerTerm,
      offerPaymentAmount: formatter.format(this.$store.getters.offerPaymentAmount),
      offerDeductionAmount: formatter.format(this.$store.getters.offerDeductionAmount),
      expectedPayments: this.$store.getters.expectedPayments
    }
  },
  computed: {},
  methods: {
    acceptOffer() {
      const paperFormSentTimestamp = this.$store.getters.paperFormSentTimestamp
      const offerStage = this.$store.getters.offerStage
      const argyleEnabled = this.$store.getters.argyleEnabled
      const argyleSubscribeAlloc = this.$store.getters.argyleSubscribeAlloc
      const defaultPaymentType = this.$store.getters.defaultPaymentType
      const ddSetupType = this.$store.getters.ddSetupType
      console.log('argyleEnabled', argyleEnabled)
      console.log('argyleDDEnabled', argyleSubscribeAlloc)
      if (
        (argyleEnabled && argyleSubscribeAlloc) ||
        ddSetupType === 'offerPaperForm' ||
        (ddSetupType === 'callUsPaper' && paperFormSentTimestamp)
      ) {
        console.log('Attempting to go to /offer/directDeposit')
        this.$router.push({ path: '/offer/directDeposit' })
      } else if (
        defaultPaymentType === 'payrollDeduction' ||
        offerStage === 'Awaiting Borrower Signature'
      ) {
        this.$router.push({ path: 'offer/contract' })
      } else {
        Swal.fire({
          title: 'Please Call Us',
          showConfirmButton: false,
          html: `<p class="mb-2 text-center">
              If you would like to accept this offer, please call us at <b>(678) 685-8834</b> to set up your automatic payments.
              <br><br>A VIVA representative will assist you with setting up your payroll repayment through this account.
              <br>Please be aware that you will need to have access to your Employee Self Service Portal to complete this process with our representatives.
              <br><br>After this is complete, we will send an email with your contract to be signed online. The funds will then be deposited directly into your bank account in 1-2 business days.
            </p>
            `,
          icon: 'info'
        })
      }
    },
    mounted() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  },
  watch: {}
}
</script>
